import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Divider, Flex, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../../../../../components/form/FormInput';
import { CodeActions, CodeActionToStatus } from '../../../../../../constants/codes';
import { selectInsured } from '../../../../../../redux/modules/insured';
import { bulkUpdateItemCodeStatuses, itemSearch } from '../../../../../../redux/modules/items';
import { hideModal } from '../../../../../../redux/modules/modal';

const ConfirmBulkCodeUpdateModal = ({ codes, codeAction }) => {
  const dispatch = useDispatch();
  const getSearchQueryParams = useSelector(itemSearch.selectRequestParamsFunction);
  const { total } = useSelector(itemSearch.selectPageInfo);
  const { insuredId } = useSelector(selectInsured);
  const status = CodeActionToStatus[codeAction];

  const useFormMethods = useForm();
  const { handleSubmit } = useFormMethods;

  const onSubmit = data => {
    const onSuccess = () => dispatch(hideModal());

    dispatch(bulkUpdateItemCodeStatuses(
      insuredId,
      codes,
      status,
      getSearchQueryParams(),
      data?.comment || null,
      onSuccess
    ));
  };

  return (
    <Box>
      <Text fontSize="lg" textAlign="center">Confirm Bulk Update</Text>
      <Divider />
      <Box mt={4}>
        Are you sure you want to perform the following action to
        <Box as="span" fontWeight="bold">
          {` ${total} `}
        </Box>
        items?
      </Box>

      <HStack
        alignItems="center"
        justifyContent="space-around"
        my={2}
        spacing={6}
      >
        <Box>
          Action:
          <Box as="span" fontWeight="semibold">
            {` ${codeAction}`}
          </Box>
        </Box>
        <Flex
          alignItems="center"
          direction="row"
          justifyContent="center"
          wrap="wrap"
        >
          <Box>
            {'Codes: '}
          </Box>
          {codes.map(code => (
            <Box
              backgroundColor="greyScale.200"
              borderRadius="5px"
              boxShadow="md"
              key={code.id}
              m={2}
              px={2}
              py={1}
              textAlign="center"
              w="33px"
            >
              {code.letter}
            </Box>
          ))}
        </Flex>
      </HStack>

      <form id="bulkApplyCodes" onSubmit={handleSubmit(onSubmit)}>
        { [CodeActions.Inquire, CodeActions.Waive].includes(codeAction) && (
        <FormInput
          inputName="comment"
          placeholder="Add an Optional Comment..."
          type="textAreaSm"
          useFormMethods={useFormMethods}
        />
        )}

        <Box my={4}>
          <Text>
            Please refresh the page after submission to see the updated codes.
            Any items that already have this code status or have a code status
            that would result in a prohibited transition will be ignored.
          </Text>
          <Text fontSize="sm" my={2}>
            Note: Larger item groups may take several minutes to process.
          </Text>
        </Box>
      </form>
    </Box>
  );
};

ConfirmBulkCodeUpdateModal.propTypes = {
  codes: PropTypes.arrayOf(PropTypes.object),
  codeAction: PropTypes.string
};

export default ConfirmBulkCodeUpdateModal;
